import { render, staticRenderFns } from "./CorporationSearchPopup.vue?vue&type=template&id=a9522520&"
import script from "./CorporationSearchPopup.vue?vue&type=script&lang=js&"
export * from "./CorporationSearchPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports